module.exports = __webpack_public_path__ + "assets/img/street-view.03adbbd8.png";